
















import vue from "vue";

export default vue.extend({
  name: "ReloadRequiredAlert",

  methods: {
    reloadThePage() {
      window.location.reload();
    }
  },

  computed: {
    modalOpen() {
      return this.$store.state.appVersionAlert;
    }
  }
});
